import React, { useState, useEffect } from 'react'
import {
  Modal,
  Button,
  Select,
  DataTable
} from '@arnsbogroup/react-voicearchive'
import { Span } from 'components/datatable'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import useApi from 'hooks/useApi'

export default NiceModal.create(() => {
  const modal = useModal()
  const [coordinators] = useApi('/rest/v2/coordinator?search[partner]=!3&pageSize=10000')
  const [dispatchers] = useApi('/rest/v2/dispatcher?orderField=created_at&orderDirection=-1&pageSize=10')
  const [nextDispatcher, setNextDispatcher] = useState(null)
  const [previousDispatchers, setPreviousDispatchers] = useState([])

  useEffect(() => {
    if (coordinators && dispatchers) {
      setPreviousDispatchers(dispatchers.map((dispatcher) => {
        const found = coordinators.find(coordinator => coordinator.uid == dispatcher.user_id)
        if (found) {
          return {...found, dispatcherSetAt: dispatcher.created_at}
        }
      }).filter(dispatcher => dispatcher))
    }
  }, [coordinators, dispatchers])

  const onSubmit = () => {
    const body = new FormData()
    body.append('coordinatorId', nextDispatcher.value)
    fetch('/dispatcher/setCurrentDispatcher.json', { 
      method: 'POST',
      body
    })
    .then(() => {
      toastr.success('Dispatcher set')
      modal.remove()
    });
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => !nextDispatcher ? undefined : onSubmit()}
      dialogPanelClasses="max-w-screen-sm overflow-x-scroll"
      title="Set current dispatcher"
    >
      <div className="m-4 space-y-4">
        <Select
          label="Dispatchers"
          description="Select a coordinator to be the next dispatcher"
          value={nextDispatcher}
          onChange={setNextDispatcher}
          options={coordinators?.map(({ uid, name }) => ({ value: uid, label: name })) }
        />
        <div>
          <h4>Previous dispatchers</h4>
          <DataTable
            head={{
              name: { sortable: true, label: 'Dispatcher' },
              dispatcherSetAt: { sortable: true, label: 'Set at' }
            }}
            body={{
              name: Span,
              dispatcherSetAt: Span
            }}
            entries={previousDispatchers}
          />
        </div>
      </div>

      <Button
        className="float-right" 
        size="sm" 
        onClick={onSubmit}
        disabled={!nextDispatcher}
      >Set dispatcher</Button>
    </Modal>
  )
})
